import { Toast } from 'antd-mobile';
import $ from "jquery";

/**
 * 添加时间戳
 */
export function addTimestamp(url)
{
    var getTimestamp = new Date().getTime();
    if (url.indexOf("?") > -1) {
        url = url + "&timestamp=" + getTimestamp
    } else {
        url = url + "?timestamp=" + getTimestamp
    }
    return url;
}

export function getHears() {
    const access_token = localStorage.getItem("access_token");
    if (!access_token) {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    }
    else
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + access_token
        }
}
export async function
    fetchData(apiPath, loadingMsg) {
    if (loadingMsg)
        Toast.loading(loadingMsg, 60);      
    return await fetch(apiPath, {
        method: 'GET',
        headers: getHears()
    }).then((response) => {
        if (loadingMsg)
            Toast.hide();
        if (!response.ok) {
            Promise.reject(response)
        }
        return response.json()
    }).then((json) => {
        if (json.status === -1) {
            Promise.reject(json);
            throw new Error(json.message);
        }
        return json;
    })
}
export async function postData(apiPath, data, loadingMsg) {
    
    if (loadingMsg)
        Toast.loading(loadingMsg, 60);
    var formData = new FormData();
    for (let k in data) {
        formData.append(k, data[k]);
    }
    var headers = getHears();
    return await fetch(apiPath, {
        method: 'POST',
        //mode: 'cors',
        headers: headers,
        body: JSON.stringify(data)
        //body: formData
    }).then((response) => {
        if (loadingMsg) {
            Toast.hide();
        }
        if (!response.ok) {
            Promise.reject(response);
            Toast.hide();
        }
        return response.json()
    }).then((json) => {
        if (json.status === -1) {
            Promise.reject(json);
            throw new Error(json.message);
        }
        if (json.status !== 0) {
            Toast.loading(json.message, 5);
        }
        return json
    });
}

export function ajaxGetData(apiPath) {    
    let ajaxdata = null;
    const access_token = localStorage.getItem("access_token");
    $.ajax({
        url: apiPath,   //网络请求url地址  
        type: 'Get',
        async: false,
        cache: false,
        processData: false,
        Accept: 'application/json',
        contentType: 'application/json',
        beforeSend: function (XMLHttpRequest) {
            XMLHttpRequest.setRequestHeader("Authorization", 'Bearer ' + access_token);
        },
        success: function (data) {
            ajaxdata = data;
        },
        error: function (result) {
            
        }
    });
    return ajaxdata;
}
